<template>
    <section id="fondoAnimado">
      <div class="fondoAnimado">
        <span class="fondoAnimado__rayo" v-for="i in 24" :key="i"></span>
        <span class="fondoAnimado__sol"></span>
      </div> 
    </section>
</template>
<script>
import { gsap } from "gsap";

export default {
  name: "FondoAnimado",
  mounted() {
    this.rotar();
  },
  methods: {
    rotar(){
      gsap.to('.fondoAnimado',{rotation: 360,duration: 900,repeat: -1})
    }
  }
};
</script>